import _ from 'lodash';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles/index';
import TerminalsContainer from '../../containers/logistics/Terminals';
import FMPSelect from './FMPSelect';
import FormComponent from '../FormComponent';

const styles = () => {
	return {
		product: {
			paddingLeft: 10,
			fontSize: 14,
			color: '#666',
			fontWeight: 100,
		},
		loading: {
			fontSize: 11,
			lineHeight: '11px',
			color: '#777',
		},
		margin: {
			margin: '5px 0px',
		},
	};
};

class FMPTerminalSupplierPicker extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			terminalId: '',
			supplierId: '',
			supplierOptions: [],
		};
	}

	componentDidMount() {
		const { terminals, searchTerminals } = this.props;

		if (_.isEmpty(terminals)) {
			searchTerminals();
		}
	}

	onTerminalChange = (terminalId) => {
		const { onChange, path } = this.props;
		const newValue = {
			terminalId,
			supplierId: '',
		};
		onChange(newValue, path);
	};

	onSupplierChange = (supplierId) => {
		const { value, onChange, path } = this.props;
		const newValue = { ...value, supplierId };
		onChange(newValue, path);
	};

	getSupplierOptions = ({ selectedTerminal }) => {
		const { supplierMap, productTypes } = this.props;
		const supplierOptions = [];
		if (!selectedTerminal) {
			return supplierOptions;
		}

		const checkProductTypes = !_.isEmpty(_.compact(productTypes));
		const map = {};
		[
			{ type: 'bulk', key: 'bulkSuppliers' },
			{ type: 'station', key: 'supplierProducts' },
		].forEach(({ key }) => {
			if (!selectedTerminal[key]) {
				return;
			}

			selectedTerminal[key].forEach((supplierProduct) => {
				const { supplierId, product } = supplierProduct;
				const supplier = supplierMap[supplierId];

				if (checkProductTypes) {
					if (!_.includes(productTypes, product)) {
						return;
					}
				}

				const key = `${supplierId}`;
				if (map[key]) {
					return;
				}
				map[key] = true;

				const option = {
					display: `${supplier.name}`,
					value: supplierId,
				};
				supplierOptions.push(option);
			});
		});
		return supplierOptions;
	};

	render() {
		const { terminals, value } = this.props;
		const { supplierId, terminalId } = value;

		if (_.isEmpty(terminals)) {
			return <div>Fetching terminals details...</div>;
		}

		const terminalOptions = [];
		terminals.forEach((terminal) => {
			terminalOptions.push({
				display: terminal.name,
				value: terminal.terminalId,
			});
		});

		const selectedTerminal = _.find(terminals, { terminalId });
		const supplierOptions = this.getSupplierOptions({ selectedTerminal });

		return (
			<Fragment>
				<FMPSelect
					{...this.setForm('terminalId', 'Terminal', true, '')}
					value={terminalId || ''}
					options={_.sortBy(terminalOptions, 'display')}
					onChange={this.onTerminalChange}
				/>

				<FMPSelect
					{...this.setForm('supplierId', 'Supplier')}
					value={supplierId || ''}
					options={_.sortBy(supplierOptions, 'display')}
					onChange={this.onSupplierChange}
				/>
			</Fragment>
		);
	}
}

FMPTerminalSupplierPicker.propTypes = {
	label: PropTypes.string,
	supplierLabel: PropTypes.string,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	value: PropTypes.object.isRequired,
	supplierError: PropTypes.string,

	searchTerminals: PropTypes.func.isRequired,
	terminals: PropTypes.array,
	supplierMap: PropTypes.object,

	productTypes: PropTypes.array,

	justBulk: PropTypes.bool,
	md: PropTypes.number,
	classes: PropTypes.object,
};

export default _.flow([withStyles(styles), TerminalsContainer])(FMPTerminalSupplierPicker);

FMPTerminalSupplierPicker.defaultProps = {
	justBulk: false,
	md: 12,
};
